module.exports = __webpack_public_path__ + "static/media/nimbus-bg.1335602c.png";